import { library } from '@fortawesome/fontawesome-svg-core';
import { faBell, faCheckCircle, faQuestionCircle, faTrashAlt, faUserCircle } from '@fortawesome/free-regular-svg-icons';
import { faChartBar, faChevronRight, faClipboardCheck, faClipboardList, faCog, faEquals, faListUl, faPencilAlt, faPlus, faPrint, faUserCog } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observe } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { SyncStore } from 'src/Stores/Sync/SyncStore';
import TenantStore from 'src/Stores/Tenant/TenantStore';
import { TestsStore } from 'src/Stores/Tests/TestsStore';
import { UserStore } from 'src/Stores/User/UserStore';
import { WellsStore } from 'src/Stores/Wells/WellsStore';
import { IUser } from '../../Interfaces/UserInterface';
import Message from '../Messaging/Message';
import ActiveReportsComponent from '../Reporting/ActiveReports/ActiveReports';
import ReportIndex from '../Reporting/ReportIndex';
import TableauReport from '../Reporting/Tableau/TableauReport';
import AdminDashboard from './Admin/Dashboard';
import Approval from './Approval/Approval';
// Well Test / Inventory Components
import Dispatch from './Dispatch/Dispatch/Dispatch';
import DispatchDetails from './Dispatch/DispatchDetails/DispatchDetails';
import { Dispatches } from './Dispatch/Dispatches/Dispatches';
import Profile from './Profile';
import Sidebar from './Sidebar';
// Well Test / Pump Volume Components
import DrillingPump from './TestWorkflow/DrillingPump';
// Well Test / Fluid Data Components
import MudProperties from './TestWorkflow/FluidData/MudProperties';
import RemarksA from './TestWorkflow/FluidData/RemarksA';
import RemarksB from './TestWorkflow/FluidData/RemarksB';
import SolidsControl from './TestWorkflow/FluidData/SolidsControl';
// import WellInformation from './TestWorkflow/WellData/WellInformation';
// Well Test / Hole Geometry Components
import BitData from './TestWorkflow/HoleGeometry/BitData';
import CasingAndInterval from './TestWorkflow/HoleGeometry/CasingAndInterval';
import DrillString from './TestWorkflow/HoleGeometry/DrillString';
import Survey from './TestWorkflow/HoleGeometry/Survey';
import EBP from './TestWorkflow/Inventory/EBP';
import Products from './TestWorkflow/Inventory/Products';
import VolumeAccounting from './TestWorkflow/Inventory/VolumeAccounting';
// Well Test / Well Data Components
import ManageContacts from './TestWorkflow/WellData/ManageContacts';
import TestSetup from './TestWorkflow/WellData/TestSetup';
import WellList from './WellList';
import EbpReview from './WellWorkflow/WellClose/EbpReview';
import IntervalCosts from './WellWorkflow/WellClose/IntervalCosts';
import ProductReview from './WellWorkflow/WellClose/ProductReview';
import RecapRemarksReview from './WellWorkflow/WellClose/RecapRemarksReview';
import WellVolumeAccounting from './WellWorkflow/WellClose/WellVolumeAccounting';
// Well Setup Components
import WellContacts from './WellWorkflow/WellContacts';
import WellDetails from './WellWorkflow/WellDetails';
import WellDispatch from './WellWorkflow/WellDispatch/WellDispatch';
import WellLocation from './WellWorkflow/WellLocation';
import WellReview from './WellWorkflow/WellReview';

library.add(faBell, faChartBar, faCheckCircle, faChevronRight, faClipboardCheck, faClipboardList, faCog, faEquals, faListUl, faPencilAlt, faPlus, faPrint, faQuestionCircle, faTrashAlt, faUserCircle, faUserCog);








@inject('stores')
@observer
class Main extends React.Component {
    public props: any;
    public userObject: IUser;
    public userObserver: any;
    public syncObserver: any;
    public wellObserver: any;
    public UserStore: UserStore;
    private TenantStore: TenantStore;
    private headerItems: any[] = [];
    public MessageStore: any;
    private SyncStore: SyncStore;
    private WellsStore: WellsStore;
    private TestsStore: TestsStore;

    public state = {
        expanded: true,
        hasUser: false,
        syncErrorModal: false,
        user: this.userObject,
        workflowHeaderItems: this.headerItems
    };

    constructor(props: any) {
        super(props);

        this.UserStore = this.props.stores.UserStore;
        this.WellsStore = this.props.stores.WellsStore;
        this.TestsStore = this.props.stores.TestsStore;
        this.MessageStore = this.props.stores.MessageStore;
        this.TenantStore = this.props.stores.TenantStore;
        this.SyncStore = this.props.stores.SyncStore;
        this.handleArrowClick = this.handleArrowClick.bind(this);
        this.onDismissAlert = this.onDismissAlert.bind(this);
        // Well Setup Components
        this.renderWellDetails = this.renderWellDetails.bind(this);
        this.renderWellLocation = this.renderWellLocation.bind(this);
        this.renderWellContacts = this.renderWellContacts.bind(this);
        this.renderWellReview = this.renderWellReview.bind(this);
        // Well Test / Well Data Components
        this.renderTestSetup = this.renderTestSetup.bind(this);
        this.renderSolidsControl = this.renderSolidsControl.bind(this);
        this.renderWellInformation = this.renderWellInformation.bind(this);
        this.renderManageContacts = this.renderManageContacts.bind(this);
        // Well Test / Hole Geometry Components
        this.renderBitData = this.renderBitData.bind(this);
        this.renderCasingAndInterval = this.renderCasingAndInterval.bind(this);
        this.renderDrillString = this.renderDrillString.bind(this);
        this.renderSurvey = this.renderSurvey.bind(this);
        // Well Test / Pump Volume Components
        this.renderDrillingPump = this.renderDrillingPump.bind(this);
        // Well Test / Fluid Data Components
        this.renderMudProperties = this.renderMudProperties.bind(this);
        this.renderRemarksA = this.renderRemarksA.bind(this);
        this.renderRemarksB = this.renderRemarksB.bind(this);
        // Well Test / Inventory Components
        this.renderEBP = this.renderEBP.bind(this);
        this.renderVolumeAccounting = this.renderVolumeAccounting.bind(this);
        this.renderProducts = this.renderProducts.bind(this);
        // Well Test / Mud Report Component

        
        this.createDisposers();
    }

    private renderDispatchHeader = () => {
        if ( this.props.match.params.task !== 'test' ) {
            return false;
        }

        if ( this.TestsStore.test && this.TestsStore.test.testStatus === "Approved") {
            return false;
        }
        
        const hasAll = this.UserStore.hasPermission('Permissions.Dispatch.Create.All');
        if (hasAll) {
            return true;
        }
        const hasAssigned = this.UserStore.hasPermission('Permissions.Dispatch.Create.Assigned');
        const well = this.WellsStore.well;
        if (hasAssigned && well && well.engineers.some(eng => eng.id === this.UserStore.user.id)) {
            return true;
        }
        return false;
    }

    private renderDispatchHeaderWell = () => {
        const hasAll = this.UserStore.hasPermission('Permissions.Dispatch.Create.All');
        if (hasAll) {
            return true;
        }
        const hasAssigned = this.UserStore.hasPermission('Permissions.Dispatch.Create.Assigned');
        const well = this.WellsStore.well;
        if (hasAssigned && well && well.engineers.some(eng => eng.id === this.UserStore.user.id)) {
            return true;
        }
        return false;
    }

    public createNavigationItems(props: any) {
        if ( props.match.params.task === 'test' ) {
            const headers = [];
            if ( props.match.params.mainTask === 'welldata' ) {
                headers.push(['Well Data', 'Hole Geometry', 'Drilling Pump', 'Fluid Data', 'Inventory'],
                             ['Test Setup', 'Manage Contacts']);
                this.setState({
                    workflowHeaderItems: headers
                });
            } else if ( props.match.params.mainTask === 'holegeometry' ) {
                headers.push(['Well Data', 'Hole Geometry', 'Drilling Pump', 'Fluid Data', 'Inventory'],
                             ['Bit Data', 'Drill String', 'Casing and Interval', 'Survey', ]);
                this.setState({
                    workflowHeaderItems: headers
                });
            } else if ( props.match.params.mainTask === 'drillingpump' ) {
                headers.push(['Well Data', 'Hole Geometry', 'Drilling Pump', 'Fluid Data', 'Inventory']);
                this.setState({
                    workflowHeaderItems: headers
                });
            } else if ( props.match.params.mainTask === 'fluiddata' ) {
                headers.push(['Well Data', 'Hole Geometry', 'Drilling Pump', 'Fluid Data', 'Inventory'],
                             ['Mud Properties', 'Solids Control', 'Tourly Treatment', 'Remarks']);
                this.setState({
                    workflowHeaderItems: headers
                });
            } else if ( props.match.params.mainTask === 'inventory' ) {
                headers.push(['Well Data', 'Hole Geometry', 'Drilling Pump', 'Fluid Data', 'Inventory'],
                             [
                                 'Products',
                                 'EBP',
                                 this.renderDispatchHeader() ? 'Dispatches' : '',
                                 'Volume Accounting'
                            ].filter(item => item !== ''));
                this.setState({
                    workflowHeaderItems: headers
                });
            }
        } else {
            const wellHeaders = [
                'Details',
                'Location',
                'Contacts',
                this.renderDispatchHeaderWell() ? 'Dispatches' : '',
                'Review'
            ].filter(item => item !== '');
            let subHeaders: string[] = [];
            if ( this.WellsStore.well && this.WellsStore.well.wellStatus !== 'Active')
            {
                wellHeaders.push('Well Close');
                if (props.match.params.task === 'wellclose') {
                    subHeaders = ['Products Review', 'EBP Review', 'Interval Cost Review', 'Volume Accounting Review', 'Recap Remarks Review'];
                }
            }
            const headers = [wellHeaders];
            if (subHeaders.length > 0) {
                headers.push(subHeaders);
            }
            this.setState({
                workflowHeaderItems: headers
            });
        }
    }

    public componentWillMount() {
        this.createNavigationItems(this.props);
    }

    public componentWillUpdate(nextProps: any) {
        const mainDiff = (nextProps.match.params.mainTask !== this.props.match.params.mainTask);
        const subDiff = (nextProps.match.params.subTask !== this.props.match.params.subTask);

        if ( mainDiff || subDiff ) {
            this.props.stores.ErrorsStore.clearAllErrors();
        }

        if ( nextProps.match.params.mainTask !== this.props.match.params.mainTask 
            || nextProps.match.params.task !== this.props.match.params.task) {
            this.createNavigationItems(nextProps);
        }
    }

    public componentDidMount() {
        if (!this.UserStore.user) {
            this.UserStore.getProfile().then(profile => {
                if (!profile) {
                    this.props.history.push('/');
                }
            });
        } else {
            this.setState({
                hasUser: true,
                user: this.UserStore.user
            });
        }
        
        if (this.SyncStore.unsyncedTests.length > 0) {
            this.setState({
                syncErrorModal: true,
            });
        }
    }

    private createDisposers() {
        this.userObserver = observe(this.UserStore, 'user', (change: any) => {
            this.setState({
                hasUser: change.newValue ? true : false,
                user: change.newValue
            });
        });

        this.syncObserver = observe(this.SyncStore, 'unsyncedTests', (change) => {
            if (change.newValue.length > 0) {
                this.setState({
                    syncErrorModal: true,
                });
            }
        });

        this.wellObserver = observe(this.WellsStore, 'well', (change => {
            this.createNavigationItems(this.props);
            return change;
        }));
    }

    public componentWillUnmount() {
        this.userObserver();
        this.syncObserver();
        this.wellObserver();
    }

    private handleDownload = () => {
        this.SyncStore.downloadErrorTests()
            .then(() => {
                this.setState({
                    syncErrorModal: false,
                });
            });
    }
    public handleArrowClick() {
        const fContent: any = document.getElementById('footer-content');

        if ( fContent !== null ) {
            fContent.classList.remove('expanded');
            if ( !this.state.expanded ) {
                fContent.classList.add('expanded');
            }
        }
        
        this.setState({
            expanded: !this.state.expanded
        });
    }

    public onDismissAlert() {
        this.setState({
            visible: false
        });
    }
    public renderWellDetails() {
        return(
            <WellDetails
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );
    }
    public renderWellLocation() {
        return(
            <WellLocation
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );
    }
    public renderWellContacts() {
        return(
            <WellContacts
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );
    }
    public renderWellReview() {
        return(
            <WellReview
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );
    }
    public renderTestSetup() {
        return(
            <TestSetup
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );
    }
    public renderSolidsControl() {
        return(
            <SolidsControl
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );
    }
    public renderWellInformation() {
        return(
            <WellReview
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );
    }
    public renderManageContacts() {
        return(
            <ManageContacts
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );
    }
    public renderBitData() {
        return(
            <BitData
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );
    }
    public renderCasingAndInterval() {
        return(
            <CasingAndInterval
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );
    }
    public renderDrillString() {
        return(
            <DrillString
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );
    }
    public renderSurvey() {
        return(
            <Survey
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );
    }
    public renderDrillingPump() {
        return(
            <DrillingPump
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );
    }
    public renderMudProperties() {
        return(
            <MudProperties
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );
    }
    public renderRemarksA() {
        return(
            <RemarksA
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );
    }
    public renderRemarksB() {
        return(
            <RemarksB
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );
    }
    public renderEBP() {
        return(
            <EBP
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );
    }
    public renderVolumeAccounting() {
        return(
            <VolumeAccounting
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );
    }
    public renderProducts() {
        return(
            <Products
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );


    }

    public renderWellCloseReviewProducts = () => {
        return(
            <ProductReview
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );
    }

    public renderWellCloseReviewEBP = () => {
        return(
            <EbpReview
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );
    }

    public renderWellCloseVolumeAccounting = () => {
        return <WellVolumeAccounting workflowHeaderItems={this.state.workflowHeaderItems} />;
    }

    public renderWellCloseRecapRemarksReview = () => {
        return(
            <RecapRemarksReview
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );
    }

    public renderWellIntervalCostsReview = () => {
        return(
            <IntervalCosts
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );
    }

    private renderHomePath = () => {
        if (this.UserStore.hasGenericPermission('Permissions.Wells.Read')) {
            return (
                    <Route
                        path="/home"
                        component={WellList}
                    />
            );
        } else if(
            this.UserStore.hasGenericPermission('Permissions.Reports.System.View')
            || this.UserStore.hasGenericPermission('Permissions.Reports.Custom.View')
        ) {
            return (
                <Route
                    path="/home"
                    component={ReportIndex}
                />
            );
        } else if(this.UserStore.hasPermission('Permissions.Admin.View')){
            return (
                <Route
                    path="/home"
                    component={AdminDashboard}
                />
            );
            
        } else if(this.UserStore.user) {
            return (
                <Route
                    path="/home"
                    component={Approval}
                />
            );
        } else {
            return '';
        }
    }

    public renderDispatch = () => {
        return(
            <Dispatch
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );
    }

    public renderWellDispatch = () => {
        return (
            <WellDispatch
                workflowHeaderItems={this.state.workflowHeaderItems}
            />
        );
    }
    public render() {
        const sidebarExpanded = this.state.hasUser;
        if (!sidebarExpanded) {
            return (
                <div />
            );
        }
        return(
            <div className="Main">
                <Message messages={this.MessageStore.messages} />
                {sidebarExpanded &&
                    <Sidebar expanded={this.state.expanded} />
                }
                {!(this.props.location.pathname.includes('mudreport') || this.props.location.pathname.includes('recap')) &&
                    <div
                        className="Arrow"
                        onClick={this.handleArrowClick}
                        style={ this.state.expanded ? {left: 175} : {left: 5} }
                        title={ this.state.expanded ? "Collapse Menu" : "Expand Menu" }>
                        <FontAwesomeIcon
                            icon="chevron-right"
                            color={this.state.expanded ? this.TenantStore.iconColor : this.TenantStore.onBrandIconColor}
                            size="2x"
                            rotation={ this.state.expanded ? 180 : undefined }
                        />
                    </div>
                }
                <div className="Content container-fluid">
                    <Switch>
                        <Route
                            path="/profile"
                            component={Profile}
                        />
                        <Route
                            path='/admin/:task:/:id'
                            component={AdminDashboard}
                        />
                        <Route
                            path='/admin/:task'
                            component={AdminDashboard}
                        />
                        <Route
                            path='/admin'
                            component={AdminDashboard}
                        />
                        {
                            this.UserStore.hasGenericPermission('Permissions.Wells.Read') &&
                            <Route
                                path="/home/:list?"
                                component={WellList}
                                exact={true}
                            />
                        }
                        {this.renderHomePath()}
                        <Route
                            path="/approvals"
                            component={Approval}
                        />
                        <Route
                            path='/submissions'
                            component={Approval}
                        />
                        <Route
                            path="/reports/:wellId?"
                            component={ReportIndex}
                        />
                        <Route
                            path="/dispatches"
                            component={Dispatches}
                            exact={true}
                        />
                        <Route
                            path="/dispatches/:dispatchId"
                            component={DispatchDetails}
                        />
                        <Route
                            path="/activereports/:reportId?"
                            component={ActiveReportsComponent}
                        />
                        <Route
                            path="/tableaureports"
                            component={TableauReport}
                        />
                            // Well Setup Routes
                        <Route
                            path='/well/:wellId/details'
                            render={this.renderWellDetails}
                        />
                        <Route
                            path='/well/:wellId/location'
                            render={this.renderWellLocation}
                        />
                        <Route
                            path='/well/:wellId/contacts'
                            render={this.renderWellContacts}
                        />
                        <Route
                            path='/well/:wellId/dispatches'
                            render={this.renderWellDispatch}
                        />
                        <Route
                            path='/well/:wellId/review'
                            render={this.renderWellReview}
                        />
                        // Well Test / Well Data Routes
                        <Route
                            path='/well/:wellId/test/:taskId/welldata/testsetup'
                            render={this.renderTestSetup}
                        />
                        <Route
                            path='/well/:wellId/test/:taskId/welldata/managecontacts'
                            render={this.renderManageContacts}
                        />
                        // Well Test / Hole Geometry Routes
                        <Route
                            path='/well/:wellId/test/:taskId/holegeometry/bitdata'
                            render={this.renderBitData}
                        />
                        <Route
                            path='/well/:wellId/test/:taskId/holegeometry/casingandinterval'
                            render={this.renderCasingAndInterval}
                        />
                        <Route
                            path='/well/:wellId/test/:taskId/holegeometry/drillstring'
                            render={this.renderDrillString}
                        />
                        <Route
                            path='/well/:wellId/test/:taskId/holegeometry/survey'
                            render={this.renderSurvey}
                        />
                        // Well Test / Pump Volume Routes
                        <Route
                            path='/well/:wellId/test/:taskId/drillingpump'
                            render={this.renderDrillingPump}
                        />
                        // Well Test / Fluid Data Routes
                        <Route
                            path='/well/:wellId/test/:taskId/fluiddata/mudproperties'
                            render={this.renderMudProperties}
                        />
                        <Route
                            path='/well/:wellId/test/:taskId/fluiddata/solidscontrol'
                            render={this.renderSolidsControl}
                        />
                        <Route
                            path='/well/:wellId/test/:taskId/fluiddata/tourlytreatment'
                            render={this.renderRemarksA}
                        />
                        <Route
                            path='/well/:wellId/test/:taskId/fluiddata/remarks'
                            render={this.renderRemarksB}
                        />
                        // Well Test / Inventory Routes
                        <Route
                            path='/well/:wellId/test/:taskId/inventory/ebp'
                            render={this.renderEBP}
                        />
                        <Route
                            path='/well/:wellId/test/:taskId/inventory/volumeaccounting'
                            render={this.renderVolumeAccounting}
                        />
                        <Route
                            path='/well/:wellId/test/:taskId/inventory/products'
                            render={this.renderProducts}
                        />
                        <Route
                            path="/well/:wellId/test/:taskId/inventory/dispatches"
                            component={this.renderDispatch}
                        />
                        <Route
                            path='/well/:wellId/wellclose/productsreview'
                            render={this.renderWellCloseReviewProducts}
                        />
                        <Route
                            path='/well/:wellId/wellclose/ebpreview'
                            render={this.renderWellCloseReviewEBP}
                        />
                        <Route
                            path='/well/:wellId/wellclose/recapremarksreview'
                            render={this.renderWellCloseRecapRemarksReview}
                        />
                        <Route
                            path='/well/:wellId/wellclose/intervalcostreview'
                            render={this.renderWellIntervalCostsReview}
                        />
                        <Route
                            path='/well/:wellId/wellclose/volumeaccountingreview'
                            render={this.renderWellCloseVolumeAccounting}
                        />
                    </Switch>
                </div>
                <Modal isOpen={this.state.syncErrorModal}>
                    <ModalHeader>
                        Download Unsynced Tests
                    </ModalHeader>
                    <ModalBody>
                        <Button color="primary" onClick={this.handleDownload}>Download</Button>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

export default withRouter(Main);



// WEBPACK FOOTER //
// ./src/Components/Main/Main.tsx